import { useTranslation } from 'react-i18next';
import { ReportStatus } from 'src/api';
import { Button } from 'src/components/atoms';
import { StyledIcon } from 'src/components/foundations/foundations.styles';

export const ReportCardEvidenceButton = (props: {
  onClick: () => void;
  reportStatus?: string;
}) => {
  const { t } = useTranslation();
  const { onClick, reportStatus } = props;

  const evidenceButtonIcon =
    reportStatus === ReportStatus.CLOSED ? 'uil-file' : 'uil-plus-circle';
  const evidenceButtonKey =
    reportStatus === ReportStatus.CLOSED
      ? 'reporting.ReportCard.viewEvidence'
      : 'reporting.ReportCard.addEvidence';

  return (
    <Button variant="secondary" onClick={onClick}>
      <StyledIcon className={evidenceButtonIcon} />
      {t(evidenceButtonKey)}
    </Button>
  );
};
